import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { JurisdictionService } from "slotworks/services/jurisdiction/jurisdiction-service";
import { SpinState } from "slotworks/state-machine/standard/states/spin-state";

export class AgsSpin extends SpinState {
    protected willSkip: boolean;

    public onEnter(): void {
        super.onEnter();
        if (!Services.get(JurisdictionService).getSpinSkippingEnabled()) {
            uiFlags.set(UIFlag.NO_SKIP, true);
        }
        this.willSkip = false;

        const gameplay = gameState.getCurrentGame();
        if (gameplay.inFreespins() && !gameplay.allFreespinsPlayed()) {
            gameWrapper.enableFeatureMode();
        }
    }

    public complete(): void {
        if (this.willSkip) {
            super.skip();
        } else {
            super.complete();
        }
    }

    public skip(): void {
        this.willSkip = true;
        this.complete();
    }
}
